function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "current",
  stroke: "current",
  cx: 9.802,
  cy: 9.802,
  r: 9.802,
  transform: "translate(7.811)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M35.211,291.813a17.5,17.5,0,0,0-5.8-13.064A2.21,2.21,0,0,0,26.5,278.7a13.663,13.663,0,0,1-17.765,0,2.206,2.206,0,0,0-2.912.045A17.569,17.569,0,0,0,0,291.8a1.937,1.937,0,0,0,1.93,1.939H33.281A1.93,1.93,0,0,0,35.211,291.813Z",
  transform: "translate(0 -258.485)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M420.654,312.049a9.672,9.672,0,0,1-3.7,1.871,1.93,1.93,0,0,0-1.377,2.4,21.227,21.227,0,0,1,.814,5.859,1.93,1.93,0,0,0,1.93,1.93h4.059a1.93,1.93,0,0,0,1.93-1.93c0-6.012.188-7.182-.634-9.343A1.925,1.925,0,0,0,420.654,312.049Z",
  transform: "translate(-377.323 -288.847)"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "current",
  stroke: "current",
  cx: 5.881,
  cy: 5.881,
  r: 5.881,
  transform: "translate(31.336 9.802)"
}));

const SvgIconPacientes = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47.008,
    height: 35.257,
    viewBox: "0 0 47.008 35.257",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPacientes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Pacientes.5199da31.svg";
export { ForwardRef as ReactComponent };